import React from 'react';
import PropTypes from 'prop-types';
import LinkToModuleResource from '../../../../common/resource/LinkToModuleResource';
import { ITINERARY_SUGGESTION_DETAIL, ROUTE_LENGTH_TYPE_OPTIONS } from '../../../../../config/constants';
import {
  BUS_ASSIGNMENT_SCHEDULE_PATH,
  CIRCUIT_PATH,
  ITINERARY_PATH,
  ROUTE_PATH,
} from '../../../../../config/paths';
import ResourceProperty from '../../../../common/resource/ResourceProperty';

const ItinerarySuggestionDetailModal = ({
  suggestionDetailList,
  previousItinerary,
}) => {
  const previousItineraryComponent = previousItinerary !== null && (
    <>
      <h4>
        Itinerario Anterior -{' '}
        <LinkToModuleResource
          text={`${previousItinerary.itineraryId}`}
          href={`${ITINERARY_PATH}/${previousItinerary.itineraryId}`}
          isExternalPath
        />
      </h4>
      <ResourceProperty label="Ruta">
        {previousItinerary.routeName}
        <LinkToModuleResource
          text=""
          href={`${ROUTE_PATH}/${previousItinerary.routeId}`}
          isExternalPath
        />
      </ResourceProperty>
      <ResourceProperty label="Circuito">
        {previousItinerary.circuitName}
        <LinkToModuleResource
          text=""
          href={`${CIRCUIT_PATH}/${previousItinerary.circuitId}`}
          isExternalPath
        />
      </ResourceProperty>
      <ResourceProperty label="Tipo">{previousItinerary.type}</ResourceProperty>
      <ResourceProperty label="Longitud">
        {ROUTE_LENGTH_TYPE_OPTIONS[previousItinerary.routeLengthType] && (ROUTE_LENGTH_TYPE_OPTIONS[previousItinerary.routeLengthType].label || 'Desconocido')}
      </ResourceProperty>
      <hr />
    </>
  );

  const getMessage = (suggestionDetail) => {
    
    let newMessage = '';

    if (ITINERARY_SUGGESTION_DETAIL[suggestionDetail.type]) {
      newMessage = ITINERARY_SUGGESTION_DETAIL[suggestionDetail.type].message;
    }

    if (suggestionDetail.message) {
      newMessage = suggestionDetail.message;
    }

    return newMessage;
  }

  return (
    <ul>
      {previousItineraryComponent}
      {suggestionDetailList.map((suggestionDetail, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <li key={index}>
          <span>{getMessage(suggestionDetail)}</span>
          {suggestionDetail.groupId &&
            suggestionDetail.type === ITINERARY_SUGGESTION_DETAIL.GROUP.value && (
              <>
                {' '}
                <LinkToModuleResource
                  text=""
                  href={`${BUS_ASSIGNMENT_SCHEDULE_PATH}/${suggestionDetail.groupId}`}
                  isExternalPath
                />
              </>
            )}
        </li>
      ))}
    </ul>
  );
};

ItinerarySuggestionDetailModal.propTypes = {
  suggestionDetailList: PropTypes.arrayOf(
    PropTypes.shape({
      message: PropTypes.string.isRequired,
      meta: PropTypes.shape({
        type: PropTypes.string,
        id: PropTypes.number,
      }),
    }),
  ).isRequired,
  previousProgrammedItinerary: PropTypes.shape({}),
  previousSuggestedItinerary: PropTypes.shape({}),
  previousItinerary: PropTypes.shape({
    itineraryId: PropTypes.number,
    routeName: PropTypes.string,
    routeId: PropTypes.number,
    routeLengthType: PropTypes.string,
    type: PropTypes.string,
    circuitId: PropTypes.number,
    circuitName: PropTypes.string,
    departureTime: PropTypes.number,
    estimatedDepartureTime: PropTypes.number,
    estimatedArrivalTime: PropTypes.number,
  }),
};

ItinerarySuggestionDetailModal.defaultProps = {
  previousProgrammedItinerary: null,
  previousSuggestedItinerary: null,
  previousItinerary: null,
};

export default ItinerarySuggestionDetailModal;
